import React, { useState, useEffect, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";

import ModalImage from "react-modal-image";
import api from "../../services/api";
import noPicture from "../../assets/nopicture.png";

const useStyles = makeStyles(theme => ({
	messageMedia: {
		objectFit: "cover",
		width: 250,
		height: "auto", // Redimensionar automaticamente a altura para manter a proporção
		borderTopLeftRadius: 8,
		borderTopRightRadius: 8,
		borderBottomLeftRadius: 8,
		borderBottomRightRadius: 8,
	}
}));

const ModalImageCors = ({ imageUrl, onError }) => {
	const classes = useStyles();
	const [fetching, setFetching] = useState(true);
	const [blobUrl, setBlobUrl] = useState("");
	const safeImageUrl = imageUrl || noPicture;
	const recovery = useRef(onError);
	recovery.current = onError;

	useEffect(() => {
		let live = true;
		let ownedUrl;
		setBlobUrl("");
		setFetching(true);

		if (!imageUrl) {
			setFetching(false);
			return;
		}

		const fetchImage = async () => {
			try {
				const { data, headers } = await api.get(imageUrl, {
					responseType: "blob",
				});
				if (!live) return;
				const url = window.URL.createObjectURL(
					new Blob([data], { type: headers["content-type"] })
				);
				ownedUrl = url;
				setBlobUrl(url);
			} catch (error) {
				if (!live) return;
				setBlobUrl(noPicture);
				if (recovery.current && !/(?:^|\/)nopicture\.png(?:[?#]|$)/.test(imageUrl)) recovery.current();
			}
			setFetching(false);
		};
		fetchImage();
		return () => {
			live = false;
			if (ownedUrl) window.URL.revokeObjectURL(ownedUrl);
		};
	}, [imageUrl]);

	return (
		<ModalImage
			className={classes.messageMedia}
			smallSrcSet={fetching ? safeImageUrl : blobUrl || safeImageUrl}
			medium={fetching ? safeImageUrl : blobUrl || safeImageUrl}
			large={fetching ? safeImageUrl : blobUrl || safeImageUrl}
			alt="image"
			showRotate={true}
		/>
	);
};

export default ModalImageCors;
